module.exports = __webpack_public_path__ + "public/img/bahan pendukung pertanian untuk petani terampil-2.1354f9d2.png";